import { ConfigConstants } from '../../config/config-constants';
import { ClientManagerInstanceToken } from '../../interfaces/client-manager.interface';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { assignModelOptions } from '../../utilities/assign-model-options';
import { TextModel } from '../primitive/text.model';
import { CompositeModel } from './composite.model';
import { EquipmentModel } from './equipment.model';

export class DataMaintenanceEquipmentModel extends CompositeModel {
    public equnr: TextModel; // key-field for equipment at gateway so needs to be sent along with request
    public measuringPoint: TextModel; // key-field for equipment at gateway so needs to be sent along with request
    public matnr: TextModel;
    public tidnr: TextModel;
    public sernr: TextModel;
    public equiShortDesc: string;
    public pos: number | undefined;
    public reasonText?: TextModel;
    public rowValueInvalid = false;
    public constructor(equipment: EquipmentModel, process: ConfigConstants.PROCESS_INDICATOR) {
        super('DataMaintenanceEquipmentModel');

        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const clientManager = injector.get(ClientManagerInstanceToken);

        this.equnr = <TextModel>this.set(new TextModel('EquipmentNum', equipment.equnr.value));
        this.measuringPoint = <TextModel>this.set(new TextModel('MeasuringPoint', equipment.measuringPoint.value));
        this.equiShortDesc = equipment.equiShortDesc.value;
        this.pos = equipment.pos.value;

        this.matnr = <TextModel>this.set(new TextModel('MaterialNum', equipment.matnr.value));
        modelOptionsLoader.load(this.matnr, 'DataMaintenanceEquipment', 'MaterialNumber', process);
        this.matnr = assignModelOptions(this.matnr, {
            ...this.matnr.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
        });

        this.tidnr = <TextModel>this.set(new TextModel('TechIdentNum', equipment.tidnr.value));
        modelOptionsLoader.load(this.tidnr, 'DataMaintenanceEquipment', 'TechnicalIdentNo');

        this.sernr = <TextModel>this.set(new TextModel('SerialNum', equipment.sernr.value));
        modelOptionsLoader.load(this.sernr, 'DataMaintenanceEquipment', 'SerialNumber');
        this.sernr = assignModelOptions(this.sernr, {
            ...this.sernr.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.SerialNumber,
        });

        if (clientManager.isNgmAA()) {
            this.reasonText = <TextModel>this.set(new TextModel('ReasonText'));
            modelOptionsLoader.load(this.reasonText, 'DataMaintenanceEquipment', 'ReasonText');
        }
    }
}

export interface ODataDataMaintenanceEquipmentOutModel extends ODataObject {
    EquipmentNum: string;
    MeasuringPoint: string;
    MaterialNum: string;
    TechIdentNum: string;
    SerialNum: string;
    ReasonText: string;
}
